module.exports = __webpack_public_path__ + "static/media/15.1b2c7714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/15.jpg
// module id = 474
// module chunks = 0